import { computed, reactive } from 'vue';
import { usePage } from '@inertiajs/vue3';

const LEVELS = Object.freeze({
    HIDDEN: 0,
    READ_ONLY: 1,
    EDITABLE: 2,
    REQUIRED: 3,
});

export default function usePolicies() {
    const page = usePage();
    const policies = computed(() => page.props.ui_policies || {});
    const cache = reactive(new Map());

    const policy = (key) => {
        if (cache.has(key) && cache.get(key)._raw === (policies.value[key] ?? LEVELS.EDITABLE)) {
            return cache.get(key);
        }

        const level = policies.value[key] ?? LEVELS.EDITABLE;

        const entry = {
            _raw: level,
            level,
            isHidden:   level === LEVELS.HIDDEN,
            canView:    level >= LEVELS.READ_ONLY,
            canEdit:    level >= LEVELS.EDITABLE,
            isRequired: level === LEVELS.REQUIRED,
            isReadOnly: level === LEVELS.READ_ONLY,
            props: Object.freeze({
                disabled: level < LEVELS.EDITABLE,
                readonly: level === LEVELS.READ_ONLY,
                required: level === LEVELS.REQUIRED,
            }),
        };

        cache.set(key, entry);
        return entry;
    };

    return { policy, LEVELS };
}
